import { useI18n } from '@affine/i18n';

import * as styles from './canvas-navigation-demo.css';

/** Two literal input demonstrations instead of abstract dots and rings. */
export function CanvasNavigationDemo() {
  const t = useI18n();
  return (
    <div className={styles.container}>
      <div className={styles.gesture}>
        <svg viewBox="0 0 144 98" aria-hidden="true" className={styles.visual}>
          <g className={styles.dragMouse}>
            <rect
              x="50"
              y="8"
              width="44"
              height="62"
              rx="22"
              className={styles.mouseBody}
            />
            <path
              d="M52 30a20 20 0 0 1 20-20v28H52Z"
              className={styles.activeInput}
            />
            <path d="M72 10v28M51 38h42" className={styles.outline} />
            <rect
              x="69"
              y="20"
              width="6"
              height="12"
              rx="3"
              className={styles.wheel}
            />
          </g>
          <path
            d="M36 86h72M44 79l-8 7 8 7M100 79l8 7-8 7"
            className={styles.direction}
          />
        </svg>
        <strong>
          {t[
            'com.streamlain.streamlain.demo-tour.canvas-navigation.pan-label'
          ]()}
        </strong>
        <span>
          {t[
            'com.streamlain.streamlain.demo-tour.canvas-navigation.pan-action'
          ]()}
        </span>
      </div>
      <div className={styles.gesture}>
        <svg viewBox="0 0 144 98" aria-hidden="true" className={styles.visual}>
          <rect
            x="18"
            y="18"
            width="44"
            height="62"
            rx="22"
            className={styles.mouseBody}
          />
          <path d="M40 20v28M19 48h42" className={styles.outline} />
          <rect
            x="36"
            y="29"
            width="8"
            height="15"
            rx="4"
            className={styles.scrollWheel}
          />
          <path d="m34 11 6-5 6 5M34 87l6 5 6-5" className={styles.direction} />
          <g className={styles.zoomObject}>
            <rect
              x="92"
              y="33"
              width="32"
              height="32"
              rx="6"
              className={styles.zoomTile}
            />
            <path d="M100 49h16M108 41v16" className={styles.direction} />
          </g>
        </svg>
        <strong>
          {t[
            'com.streamlain.streamlain.demo-tour.canvas-navigation.zoom-label'
          ]()}
        </strong>
        <span>
          {t[
            'com.streamlain.streamlain.demo-tour.canvas-navigation.zoom-action'
          ]()}
        </span>
      </div>
    </div>
  );
}
